var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareandarrowdownfill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "9.2656 -79.1621 69.7012 84.1055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9766 4.44336L62.2559 4.44336C72.6562 4.44336 78.4668-1.36719 78.4668-11.7676L78.4668-41.4062C78.4668-51.8066 72.6562-57.5684 62.2559-57.5684L25.9766-57.5684C15.5762-57.5684 9.76562-51.8066 9.76562-41.4062L9.76562-11.7676C9.76562-1.36719 15.5762 4.44336 25.9766 4.44336Z M44.0918-78.6621C45.9961-78.6621 47.6074-77.1484 47.6074-75.293L47.6074-37.2559L47.3145-31.3965L49.2676-33.4961L54.6387-39.3555C55.2734-40.0879 56.1523-40.3809 57.0312-40.3809C58.8379-40.3809 60.2051-39.1113 60.2051-37.3535C60.2051-36.4258 59.8145-35.6934 59.1797-35.0586L46.6309-23.0957C45.752-22.168 45.0195-21.9238 44.0918-21.9238C43.2129-21.9238 42.4805-22.168 41.6016-23.0957L29.0527-35.0586C28.3691-35.6934 28.0273-36.4258 28.0273-37.3535C28.0273-39.1113 29.3457-40.3809 31.1523-40.3809C32.0312-40.3809 32.959-40.0879 33.5449-39.3555L38.9648-33.4961L40.918-31.3965L40.625-37.2559L40.625-75.293C40.625-77.1484 42.2363-78.6621 44.0918-78.6621Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareandarrowdownfill);
export default __webpack_public_path__ + "static/media/square.and.arrow.down.fill.8d86a30ff0c5ba6d212b6031d265125b.svg";
export { ForwardRef as ReactComponent };